import { render, staticRenderFns } from "./CryptomatsСhecks.vue?vue&type=template&id=4018e2ae&scoped=true&"
import script from "./CryptomatsСhecks.vue?vue&type=script&lang=js&"
export * from "./CryptomatsСhecks.vue?vue&type=script&lang=js&"
import style0 from "./CryptomatsСhecks.vue?vue&type=style&index=0&id=4018e2ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4018e2ae",
  null
  
)

export default component.exports